import React from 'react';
import Head from 'next/head';
import { GetServerSideProps, GetServerSidePropsResult } from 'next';
import { BootstrapLoadingWrapper } from 'components/BootstrapLoadingWrapper';
import API from 'utils/ServerSideAPI';
import { CoachJoinFormData } from 'hevy-shared';
import { AcceptInviteScreen } from 'screens/Coach/AcceptInviteScreen';
import { t } from 'translations/t';

import { BrowserLanguageProps } from 'utils/types';
import { browserLanguageFromContext } from 'utils/pageUtils';

export const getServerSideProps: GetServerSideProps = async (
  context,
): Promise<GetServerSidePropsResult<CoachJoinFormData & BrowserLanguageProps>> => {
  const coachUsername = context.query.coachUsername;

  if (!coachUsername || typeof coachUsername !== 'string')
    return { redirect: { destination: '/404', permanent: false } };
  try {
    const result = await API.getCoachJoinFormMetadata(coachUsername);

    return {
      props: { ...result.data, isAuthenticated: false, ...browserLanguageFromContext(context) },
    };
  } catch (error) {
    return { redirect: { destination: '/404', permanent: false } };
  }
};

export default function AcceptInvite(props: CoachJoinFormData & BrowserLanguageProps) {
  const { coachUsername, coachFullname, coachProfileImageUrl } = props;
  return (
    <>
      <Head>
        <title>{t('web.metadata.signUp.title')}</title>
        <meta name="description" content={t('web.metadata.desc1')} />
      </Head>
      <BootstrapLoadingWrapper>
        <AcceptInviteScreen
          coachUsername={coachUsername}
          coachProfilePic={coachProfileImageUrl}
          coachName={coachFullname}
        />
      </BootstrapLoadingWrapper>
    </>
  );
}
